import { render, staticRenderFns } from "./LetterSelector.vue?vue&type=template&id=5cc21dfb&scoped=true"
import script from "./LetterSelector.vue?vue&type=script&lang=js"
export * from "./LetterSelector.vue?vue&type=script&lang=js"
import style0 from "./LetterSelector.vue?vue&type=style&index=0&id=5cc21dfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc21dfb",
  null
  
)

export default component.exports